export default function StateWindow({location,value}){

  return false && (
    <div class="tm">
      <pre style={{color:'cyan', fontWeight:'bold'}}>{JSON.stringify(value,null,1)}</pre>
    </div>

  )

}
